import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteExpediaCategory,
    fetchExpediaCategories,
    importExpediaCategories,
    postExpediaCategory
} from '../../../../../api/expediaApi/expediaCategories'
import { selectCategories, selectCategoriesFetching } from '../../../../../selectors/expediaSelectors/expediaCategories'
import { selectCurrentOrganization } from '../../../../../selectors/expediaSelectors/expediaCurrentOrganization'
import { selectEasymsCategoriesKV } from '../../../../../selectors/expediaSelectors/expediaEasymsSelector'
import CategoriesTable from './CategoriesTable'

const TabContainer = props => (
    <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
    </Typography>
)

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 150,
        textAlign: 'left'
    },
    menu: {
        width: 150
    },
    margin: {
        margin: theme.spacing.unit
    }
})

class CategoriesTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        categories: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchExpediaCategories: PropTypes.func.isRequired,
        postExpediaCategory: PropTypes.func.isRequired,
        deleteExpediaCategory: PropTypes.func.isRequired,
        importExpediaCategories: PropTypes.func.isRequired,
        currentOrganization: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }

    state = {
        ourId: '',
        remoteId: '',
        remoteName: ''
    }

    componentDidMount() {
        const params = { organizationId: this.props.currentOrganization }
        this.props.fetchExpediaCategories(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { organizationId: this.props.currentOrganization }
            this.props.fetchExpediaCategories(params)
            this.setState({ ourId: '' })
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleClick = () => {
        const { ourId, remoteId, remoteName } = this.state
        this.props.postExpediaCategory({
            organizationId: this.props.currentOrganization,
            ourId,
            remoteId: remoteId.trim(),
            remoteName: remoteName.trim(),
            active: true
        })

        this.setState({
            ourId: '',
            remoteId: '',
            remoteName: ''
        })
    }

    handleDelete = remoteId => {
        this.props.deleteExpediaCategory(remoteId)
    }

    handleLoadImport = () => {
        this.props.importExpediaCategories()
    }

    handleUpdate = category => {
        this.props.postExpediaCategory({
            organizationId: this.props.currentOrganization,
            ourId: category.ourId,
            remoteId: category.remoteId,
            remoteName: category.remoteName,
            active: category.active
        })
    }

    render() {
        const { classes, fetching, categories, currentOrganization, easymsCategoriesKV } = this.props
        const { ourId, remoteId, remoteName } = this.state

        const valid = ourId && remoteId.trim() && remoteName.trim()

        return (
            <div className={classes.root}>
                <div className={classes.root}>
                    <Paper className={classes.paper}>
                        <TextField
                            select
                            label="Категория EasyMS"
                            className={classes.formControl}
                            value={ourId}
                            onChange={this.handleSelect('ourId')}
                        >
                            {easymsCategoriesKV.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>

                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="categories-remote-id">ID категории Expedia.com</InputLabel>
                            <Input
                                id="categories-remote-id"
                                name="remoteId"
                                value={remoteId}
                                onChange={this.handleChange}
                            />
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="categories-remote-name">Имя категории Expedia.com</InputLabel>
                            <Input
                                id="categories-remote-name"
                                name="remoteName"
                                value={remoteName}
                                onChange={this.handleChange}
                            />
                        </FormControl>

                        <Button
                            disabled={!valid}
                            variant="raised"
                            color="primary"
                            className={classes.button}
                            onClick={this.handleClick}
                        >
                            Сохранить
                        </Button>
                    </Paper>

                    <Button
                        disabled={!currentOrganization}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleLoadImport}
                    >
                        Импортировать категории с Expedia.com
                    </Button>
                </div>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <CategoriesTable
                        categories={categories}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        categories: selectCategories(state),
        fetching: selectCategoriesFetching(state),
        currentOrganization: selectCurrentOrganization(state),
        easymsCategoriesKV: selectEasymsCategoriesKV(state)
    }),
    { fetchExpediaCategories, postExpediaCategory, deleteExpediaCategory, importExpediaCategories }
)(withStyles(styles, { withTheme: true })(CategoriesTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/CategoriesTab/CategoriesTab.js